import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { useLoad } from "@redotech/react-util/load";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoMerchantSmsTemplatesRpcClientContext } from "@redotech/redo-merchant-app-common/sms-templates-rpc-client-provider";
import { SendSmsState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import * as selectCss from "@redotech/redo-return-ui/flows/return-flow/select.module.css";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { Flex } from "@redotech/redo-web/flex";
import { Link } from "@redotech/redo-web/link";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { Spinner, SpinnerStyle } from "@redotech/redo-web/spinner";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { getTemplateTypeLabel } from "./util";

export const SendSmsDetails = memo(function SendSmsDetails({
  state,
  stepSelect,
  setState,
}: StepTypeDetailsProps<SendSmsState>) {
  const { t } = useTranslation();
  const marketingRpcClient = useRequiredContext(
    RedoMerchantSmsTemplatesRpcClientContext,
  );
  const smsLoad = useLoad(async () => {
    const templates = await marketingRpcClient.paginateSmsTemplates({
      page: 1,
      pageSize: 1000,
    });
    return templates;
  }, []);
  const nextStepChange = useHandler((next: StepId | undefined) => {
    setState((state) => ({ ...state, next }));
  });

  return (
    <>
      <Flex align="center" gap="xs">
        <Text fontSize="xs" textColor="secondary">
          {t("SMS template")}
        </Text>
        <Link to="../../sms-templates">{t("Create new")}</Link>
      </Flex>
      {smsLoad.value ? (
        <SelectDropdown
          disabled={!smsLoad.value}
          options={smsLoad.value.data || []}
          value={smsLoad.value.data?.find(
            (template: any) => template._id === state.smsId,
          )}
          valueChange={(e: any) =>
            setState((state) => ({
              ...state,
              smsId: e._id,
              smsName: e.name,
              smsType: e.templateType,
            }))
          }
        >
          {(type) => (
            <div className={selectCss.value}>
              <div className={selectCss.title}>
                {type.templateType
                  ? t("{{templateName}} - {{templateType}}", {
                      templateName: type.name,
                      templateType: getTemplateTypeLabel(t, type.templateType),
                    })
                  : type.name}
              </div>
            </div>
          )}
        </SelectDropdown>
      ) : (
        <Flex align="center" justify="center">
          <Spinner style={SpinnerStyle.AUTO} />
        </Flex>
      )}
      <Text fontSize="xs" textColor="secondary">
        {t("Next step")}
      </Text>
      {stepSelect({ value: state.next, valueChange: nextStepChange })}
    </>
  );
});
